import { motion } from "framer-motion";
import { CheckCircle2, Award } from "lucide-react";
import { IMAGES } from "../data";

const POINTS = [
  "Authorized OSHA Outreach Trainer (10 & 30 hour)",
  "NCCER Master Trainer & Evaluator (licensed)",
  "HBI Master Trainer & Evaluator (licensed)",
  "40 years in construction & general industry",
  "Published author & keynote speaker",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#D4AF37]" />
            <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#D4AF37]">The Foundation</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
            Four Decades of <span className="gold-text">Hard-Won</span> Expertise
          </h2>
          <p className="mt-6 text-lg text-[#A3A8B8] leading-relaxed max-w-2xl">
            On This Rock LLC is built on a simple belief: safety isn't a checkbox — it's a foundation.
            With 40 years on job sites across the construction and general industry, our training turns
            compliance into culture and workers into leaders.
          </p>

          <div className="mt-6 flex flex-wrap gap-2" data-testid="about-roles">
            {["Life Coach", "Business Coach", "Pastor", "Mentor"].map((r) => (
              <span key={r} className="text-xs uppercase tracking-wider font-bold text-[#D4AF37] border border-[#D4AF37]/40 px-3 py-1.5">
                {r}
              </span>
            ))}
          </div>

          <div className="mt-10 grid sm:grid-cols-1 gap-3 max-w-xl">
            {POINTS.map((p) => (
              <div key={p} className="flex items-start gap-3 bg-[#0C142A] border border-[#1D2847] p-4 hover:border-[#D4AF37]/50 transition-colors">
                <CheckCircle2 className="text-[#D4AF37] shrink-0 mt-0.5" size={20} />
                <span className="text-[#F8F9FA]">{p}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="lg:col-span-5"
        >
          <div className="relative">
            <img src={IMAGES.about} alt="Founder of On This Rock LLC" className="w-full h-[520px] object-cover object-top border border-[#1D2847]" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050A15]/70 to-transparent" />
            <div className="absolute -bottom-6 -left-6 bg-[#D4AF37] text-[#050A15] p-6 max-w-[230px] shadow-xl">
              <Award size={28} />
              <div className="mt-3 font-display font-black text-2xl leading-none">Master Trainer</div>
              <div className="mt-1 text-sm font-semibold">NCCER &amp; HBI Licensed Evaluator</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
